import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface PromoCode {
  code: string;
  discount: number;
  is_valid: boolean;
  is_used: boolean;
  is_expired: boolean;
  expire_date: string;
  created_at: string;
  order_id?: number | null;
}

export interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
  page: number | null;
}

export interface PromoCodesResponse {
  data: Array<PromoCode>;
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    current_page: number;
    from: number;
    last_page: number;
    links: Array<PaginationLink>;
    path: string;
    per_page: number;
    to: number;
    total: number;
  };
}

export const getPromoCodesQuery = (page = 1) =>
  queryOptions({
    queryKey: queryKeys.promoCodes.all(page),
    queryFn: async () => {
      const response = await api
        .get('promo-codes', { searchParams: { page } })
        .json<PromoCodesResponse>();
      return response;
    },
  });
